module.exports = __webpack_public_path__ + "static/img/03.abf776b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/03.png
// module id = 7rl+
// module chunks = 2